import React from 'react';

interface EmptyStateProps {
  title: string;
  hint?: string;
  children?: React.ReactNode;
}

export function EmptyState({ title, hint, children }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <div className="empty-state-title">{title}</div>
      {hint && <div className="empty-state-text">{hint}</div>}
      {children}
    </div>
  );
}
